import {
    Grid,
    TextField,
    Box,
    Link,
    Button,
    Dialog,
    Slide,
    Checkbox,
    FormControlLabel,
    Typography,
    DialogActions,
    Divider
} from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import { useState, forwardRef } from 'react';
import Login from './Login';
import RegisterForm from './RegisterForm';
import RegisterConfirm from './RegisterConfirm';
import RegisterConfirm2 from './RegisterConfirm2';
import { useHistory } from 'react-router-dom';
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function RegisterMain(props) {
    const { goNextPage, goPreviousPage } = props;

    const [agree1, setAgree1] = useState(false);
    const [agree2, setAgree2] = useState(false);
    const [showAgree1, setShowAgree1] = useState(false);
    const [showAgree2, setShowAgree2] = useState(false);

    const history = useHistory();

    const openAgree1Click = () => {
        setShowAgree1(true);
    }
    const closeAgree1Click = () => {
        setShowAgree1(false);
    }
    const openAgree2Click = () => {
        setShowAgree2(true);
    }
    const closeAgree2Click = () => {
        setShowAgree2(false);
    }

    const onConfirm1Click = () => {
        setAgree1(true);
        closeAgree1Click();
    };
    const onConfirm2Click = () => {
        setAgree2(true);
        closeAgree2Click();
    };
    return (
        <Grid className="headercontainer"
            container
            height="100vh"
            direction="column"
            justifyContent="center"
            alignItems="space-between">

            {/* 서비스 약관 */}
            <Dialog fullScreen open={showAgree1} onClose={closeAgree1Click} TransitionComponent={Transition}>
                <Box>
                    <Box
                        sx={{
                            width: '90%',
                            textAlign: 'left',
                            padding: '30px 0 10px 10px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-start'
                        }}>
                        <img src='/img/back_button_black.png' onClick={closeAgree1Click} />
                        <Box
                            sx={{
                                margin: '16px 0 0 10px',
                                fontSize: '25px',
                                fontWeight: 'bold'
                            }}>
                            서비스 이용약관 동의
                        </Box>
                    </Box>
                    <Divider />
                    <RegisterConfirm onClose={closeAgree1Click}></RegisterConfirm>
                    <DialogActions>
                        <Box
                            sx={{
                                position: 'fixed',
                                bottom: 0,
                                right: 0,
                                padding: '10px',
                                width: '100%',
                                background: 'white',
                                textAlign: 'right'
                            }}>
                            <Button variant="contained" onClick={onConfirm1Click} sx={{ marginRight: '10px', background: '#0092a2', ':hover': { background: '#0092a2' } }}>
                                동의
                            </Button>
                            <Button variant="outlined" onClick={closeAgree1Click} sx={{ color: 'black', border: '1px solid black'}}>
                                취소
                            </Button>
                        </Box>
                    </DialogActions>
                </Box>
            </Dialog>

            {/* 개인정보수집 */}
            <Dialog fullScreen open={showAgree2} onClose={closeAgree2Click} TransitionComponent={Transition}>
                <Box>
                    <Box
                        sx={{
                            width: '90%',
                            textAlign: 'left',
                            padding: '30px 0 10px 10px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-start'
                        }}>
                        <img src='/img/back_button_black.png' onClick={closeAgree2Click} />
                        <Box
                            sx={{
                                margin: '16px 0 0 10px',
                                fontSize: '25px',
                                fontWeight: 'bold'
                            }}>
                            개인정보 수집 및 이용에 대한 동의
                        </Box>
                    </Box>
                    <Divider />
                    <RegisterConfirm2 onClose={closeAgree2Click}></RegisterConfirm2>
                    <DialogActions>
                        <Box
                            sx={{
                                position: 'fixed',
                                bottom: 0,
                                right: 0,
                                padding: '10px',
                                width: '100%',
                                background: 'white',
                                textAlign: 'right'
                            }}>
                            <Button variant="contained" onClick={onConfirm2Click} sx={{ marginRight: '10px',  background: '#0092a2', ':hover': { background: '#0092a2' } }}>
                                동의
                            </Button>
                            <Button variant="outlined" onClick={closeAgree2Click} sx={{ color: 'black', border: '1px solid black'}}>
                                취소
                            </Button>
                        </Box>
                    </DialogActions>
                </Box>
            </Dialog>

            <Grid className="formcontainer"
                container
                direction="column"
                justifyContent="space-between"
                flex="1"
                height='100vh'
                width="100%">

                <Grid className="logo"
                    container
                    direction="column"
                    marginTop='150px'
                >
                    <img className="logoimg" src="/img/docircuit_logo.png" style={{ width: "50%", marginLeft: '15px', }} />
                    <Box
                        sx={{
                            fontSize: '22px',
                            marginLeft: '15px',
                            marginTop: '20px'
                        }}>
                        두써킷에 오신 걸
                        <br></br>
                        환영합니다!
                    </Box>
                </Grid>

                <Box>
                <FormControlLabel
                    sx={{
                        width: "100%",
                        justifyContent: "center",
                        margin: 0,
                        margin: "5px 0 10px 0",
                    }}
                    onClick={openAgree1Click}
                    control={
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-around",
                                width: "90%",
                                height: "35px",
                                border: "1px solid #e5e5e5",
                                borderRadius: "12px",
                            }}
                        >
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    width: "80%",
                                }}
                            >
                                <Checkbox
                                    disabled={true}
                                    checked={agree1}
                                    icon={<RadioButtonUncheckedIcon />}
                                    checkedIcon={<CheckCircleIcon />}
                                    sx={{
                                        width: "20%",
                                        "&.Mui-checked": {
                                            color: "#0092a2",
                                        },
                                    }}
                                />
                                <Typography
                                    fontSize={15}
                                    color="#9fa0a0"
                                    fontWeight="bold"
                                >
                                    서비스 이용약관 동의 (필수)
                                </Typography>
                            </Box>
                            <img src="/img/back_gray.png" />
                        </Box>
                    }
                    label=""
                />

                <FormControlLabel
                    sx={{
                        width: "100%",
                        justifyContent: "center",
                        margin: 0,
                        margin: "5px 0 10px 0",
                    }}
                    onClick={openAgree2Click}
                    control={
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-around",
                                width: "90%",
                                height: "35px",
                                border: "1px solid #e5e5e5",
                                borderRadius: "12px",
                            }}
                        >
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    width: "80%",
                                }}
                            >
                                <Checkbox
                                    disabled={true}
                                    checked={agree2}
                                    icon={<RadioButtonUncheckedIcon />}
                                    checkedIcon={<CheckCircleIcon />}
                                    sx={{
                                        width: "20%",
                                        "&.Mui-checked": {
                                            color: "#0092a2",
                                        },
                                    }}
                                />
                                <Typography
                                    fontSize={15}
                                    color="#9fa0a0"
                                    fontWeight="bold"
                                >
                                    개인정보 수집 동의 (필수)
                                </Typography>
                            </Box>
                            <img src="/img/back_gray.png" />
                        </Box>
                    }
                    label=""
                />
                </Box>
                

                <Grid className="regbutton"
                    container
                    direction="column"
                    justifyContent="center"
                    alignItems="center">
                    {agree1 === false || agree2 === false ?
                    <Button variant="contained" disabled
                    style={{
                        width: "100%",
                        // background: "#",
                        position: 'fixed',
                        padding: '7px 0',
                        borderRadius: 0,
                        bottom: '20px',
                        zIndex: 100
                    }}
                    // onClick={goNextPage}
                    >회원가입 시작하기</Button>
                    :
                    <Button variant="contained"
                        style={{
                            width: "100%",
                            background: "#0092a2",
                            position: 'fixed',
                            padding: '7px 0',
                            borderRadius: 0,
                            bottom: '20px',
                            zIndex: 100
                        }}
                    onClick={goNextPage}
                    >회원가입 시작하기</Button>
                    }
                    
                <Box sx={{ width: '100%', height: '20px', bottom: 0, position: 'fixed', background: 'white'}}></Box>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default RegisterMain;